export default __webpack_public_path__ + "static/media/1790.5f75c458.png";